export default __webpack_public_path__ + "static/media/Bow of the Masked Hunter.a152a273.jpg";